export default __webpack_public_path__ + "static/media/Blue geode2.fc16123b.jpg";